import Avatar from '@decisiv/ui-components/lib/components/Avatar';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import Tooltip from '@decisiv/ui-components/lib/components/Tooltip';

import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function ManagersCell({ rowData: { managers } }: CellProps) {
  return (
    <Flex>
      {managers.map(({ id, name }) => (
        <Tooltip target={<Avatar key={id} name={name} />}>{name}</Tooltip>
      ))}
    </Flex>
  );
}
